import React from "react";
import { Link } from "react-router-dom";
import { Footer } from "./Footer";
import firstfellowpartnersWhitePng1 from "../assets/images/first-fellow-partners-white.png";
import StaggeredMenu from "./ui/StaggeredMenu";

export const NotFoundPage = () => {
  const menuItems = [
    { label: 'Our Manifesto', ariaLabel: 'View our manifesto', link: '/manifesto' },
    { label: 'Family Members', ariaLabel: 'View family members', link: '/family' },
    { label: 'Team', ariaLabel: 'Meet our team', link: '/team' },
    { label: 'References', ariaLabel: 'View references', link: '/references' },
    { label: 'Get in touch', ariaLabel: 'Get in touch with us', link: '/contact' }
  ];

  const socialItems = [
    { label: 'Twitter', link: 'https://twitter.com' },
    { label: 'LinkedIn', link: 'https://linkedin.com' }
  ];

  return (
    <div className="bg-[#121212] w-full min-h-screen overflow-y-auto scrollbar-default flex flex-col items-center justify-center">
      {/* Navbar */}
      <div className="w-full bg-[#121212] border-b border-[#424242] z-50 absolute top-0">
        <div className="flex justify-between items-center px-10 py-4">
          {/* Logo on the left */}
          <Link to="/" className="w-[140px] h-[140px]">
            <img
              className="w-full h-full object-contain"
              alt="First Fellow Partners logo"
              src={firstfellowpartnersWhitePng1}
            />
          </Link>

          {/* StaggeredMenu button on the right */}
          <div className="w-[120px] h-[120px] flex items-center justify-end">
            <StaggeredMenu
              position="right"
              items={menuItems}
              socialItems={socialItems}
              displaySocials={true}
              displayItemNumbering={true}
              menuButtonColor="#fff"
              openMenuButtonColor="#000"
              changeMenuColorOnOpen={true}
              colors={['#1a1a1a', '#424242']}
              logoUrl=""
              accentColor="#000"
              isFixed={true}
              onMenuOpen={() => console.log('Menu opened')}
              onMenuClose={() => console.log('Menu closed')}
            />
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col items-center justify-center px-10 py-20 mt-40">
        <h1 className="text-white text-6xl md:text-8xl font-bold mb-6">404</h1>
        <h2 className="text-white text-2xl md:text-4xl font-light mb-8 text-center">
          Page Not Found
        </h2>
        <p className="text-white/75 text-lg md:text-xl mb-12 text-center max-w-2xl">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          className="px-8 py-4 bg-white text-black font-medium rounded-lg hover:bg-white/90 transition-colors duration-200"
        >
          Return to Homepage
        </Link>
      </div>

      {/* Footer */}
      <div className="w-full mt-auto">
        <Footer />
      </div>
    </div>
  );
};

